import type { MaybeRefOrGetter } from 'vue'

/**
 * Get a RouterLink target to the filter list with the provided params set to their according values
 */
export function useFilterLink(params: MaybeRefOrGetter<Partial<FilterInput.Record>>) {
  const filterInputStore = useFilterInputStore()

  const result = computed(() => {
    const record = toValue(params)
    const entries = Object.entries(record)
    const queryEntries = entries.map(([key, value]: any) => {
      const param = (filterInputStore.params as any)[key]
      return [param.name, param.serialize(value)]
    }) as [string, string][]

    return {
      name: 'list',
      query: Object.fromEntries(queryEntries),
    }
  })

  return result
}
